import { useParams } from 'react-router-dom';

import { PricingModelRoutesParams } from 'src/features/pricingModel/routes';

export function useSelectedPricingModelId() {
  const { selectedPricingModelId } = useParams<PricingModelRoutesParams>();
  return selectedPricingModelId;
}
